import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeightAdjustDirectiveSharedModule } from '@shared/core/directives/heightAdjust/height-adjust.directive.shared.module';

import { ModalsComponentsModule } from '../../components';

import { ModalTypeDynamicHeightComponent } from './modal-type-dynamic-height.shared.component';

@NgModule({
    declarations: [
        ModalTypeDynamicHeightComponent,
    ],
    imports: [
        CommonModule,
        HeightAdjustDirectiveSharedModule,
        ModalsComponentsModule,
    ],
    exports: [
        ModalTypeDynamicHeightComponent,
    ],
    providers: [],
})
export class ModalTypeDynamicHeightModule { }
